module.exports = __webpack_public_path__ + "static/media/no_results.83c2394d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_results.svg
// module id = 179
// module chunks = 0